import React from "react";
import { Flex, Box } from "grid-styled";
import { Field, reduxForm } from "redux-form";
import Button, { LinkButton } from "./Button";
import { H1 } from "./Heading";
import FormSection from "./forms/FormSection";
import InputContainer from "./forms/InputContainer";
import Select from "./forms/Select";
import Checkbox from "./forms/Checkbox";

const validate = ({ password, passwordConfirmation }, { newUser }) => {
  let errors = {};

  if (newUser && !password) {
    errors.password = "Password is required.";
  } else if (password) {
    if (password.length < 5) {
      errors.password = "Password is too short.";
    }

    if (password.length > 72) {
      errors.password = "Password is too long.";
    }
  }

  if (password !== passwordConfirmation) {
    errors.passwordConfirmation = "Passwords do not match.";
  }

  return errors;
};

const UserEditForm = ({
  newUser,
  pristine,
  submitting,
  handleSubmit,
  extraButtons
}) => (
  <Box p={3}>
    <form onSubmit={handleSubmit}>
      <H1>{newUser ? "Add a new user" : "Update user"}</H1>
      <FormSection title="User Info">
        <Box pb={2}>
          <Field
            name="email"
            labelText="Email"
            placeholder="e.g., nathan@jamesoninc.com"
            component={InputContainer}
          />
        </Box>
        <Box pb={2}>
          <Field
            name="role"
            labelText="Role"
            component={InputContainer}
            fieldComponent={Select}
            options={[
              { value: "admin", label: "Admin" },
              { value: "manager", label: "Manager" },
              { value: "draftsman", label: "Draftsman" },
              { value: "franchisee", label: "Franchisee" }
            ]}
          />
        </Box>
        <Box pb={2}>
          <Field
            name="name"
            labelText="Name"
            placeholder="e.g., Nathan Drake"
            component={InputContainer}
          />
        </Box>
        <Box pb={2}>
          <Field
            name="phone"
            labelText="Phone"
            placeholder="e.g., 555-555-5555"
            component={InputContainer}
          />
        </Box>
        <Box>
          <Field
            name="receiveNotifications"
            labelText="Receive notifications about new job activity?"
            component={Checkbox}
          />
        </Box>
      </FormSection>
      <FormSection title={`${newUser ? "Create" : "Change"} Password`}>
        <Box pb={2}>
          <Field
            name="password"
            type="password"
            labelText="Password"
            placeholder="e.g., •••••••••••"
            component={InputContainer}
          />
        </Box>
        <Box>
          <Field
            name="passwordConfirmation"
            type="password"
            labelText="Password Confirmation"
            placeholder="e.g., •••••••••••"
            component={InputContainer}
          />
        </Box>
      </FormSection>
      <FormSection>
        <Flex w={1}>
          <Button
            variant="primary"
            disabled={pristine || submitting}
            type="submit"
          >
            {newUser ? "Create" : "Update"} user
          </Button>
          <LinkButton to="/admin/users" style={{ marginLeft: 4 }}>
            Cancel
          </LinkButton>
          {extraButtons}
        </Flex>
      </FormSection>
    </form>
  </Box>
);

export default reduxForm({
  form: "userEdit",
  validate
})(UserEditForm);



// WEBPACK FOOTER //
// ./src/components/UserEditForm.js